<template>
  <transition name="opacity">
    <div id="loading" v-if="state">
      <svg
        version="1.1"
        id="レイヤー_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 872.8 363.2"
        style="enable-background: new 0 0 872.8 363.2"
        xml:space="preserve"
      >
        <g>
          <path
            d="M457,275.6c3.6-4,10.1-2.6,13.2,2.4c16.8-1.4,30.9-17.4,22.7-34c-40.7-14.3-22.3-7.9-62.3-1c1.8-7.8,19-8.6,13.1-16.2
  c19.1-8.9,33.8-30,3.7-37.8c3.8-6.8,7.9-17.8,15.9-18.7c-4.4-17.2-22.8-18.3-39.3-18.2c-16.2,9.5-9.4-12-9.7-22.2
  c7-6.7,17.8-13.1,25.4-21.4c2.4-5.8-3.9-7.3,0-11.7c16-4.8,3.6,15.8,3.8,24.6c5.2,5.8,4.9,14,1.8,19.9c5.4-0.5,4.1,5.6,5.1,9
  c6.7,3.9,10.8,0.9,15.6-3.9c11.5,0.8,22.9-4.9,34.6-3.4c16.2-9.2,10.3-26.2,39.3-13.6c54-1.2,12.1-48.4-16.5-57.8
  c-16.4-4.7-34.9-10.7-51.7-5.5c-3.5,1.6-5.5-0.9-3.4-4.5c-4.8,11-55.1,36.3-32.4,37.1c-2.7,4.5-25.5,19.4-23,7.1
  c-6.9,5.8-1.4-1.5,0.4-4.3c-2.1-3.9-0.8-7.7-0.8-11.9c3.8,4.7,1-9.6,3.3-13c-5.5,2.9-2.3-12.3-0.4-14.8c2.9-21.8,29.6-19.8,47-25.3
  c7.3-2.7,42.8-7.8,29.3-9.6c3-1.1-3.6-3.3,5.7-2.7c-2.4-4.3,12.1-3.1,17.2-9.2c-42.1,1.9-87.4,19-128.3,19.8
  c11.3-1.3,57-21.6,58.6-13.7c4.2-6.9,9.8-1.2,15.6-7.1c-19.4,0.4-37.9,9.1-57.4,9.2c14.6-6.3,31-7.4,46.2-12
  c-16-1-32.1,8.1-48.4,7.9c0.5-0.6,1.1-1.2,2.3-2.5c-11.7,2.6-22.5,5-33.9,7.5c4.2-10.4-14.6,0.5-20.2-1.9c-7.9,2.4-17,0.1-24.9-0.1
  c-16.8,10.5-5.4,14.2-16.1,17.9c14.3,0.5,25.4,10.2,39.6,11.6c-4.2,1.5-6.2,0.5-10.7-0.7c22.5,14.7,0.3,32.1-0.6,53.3
  c-4.9,12.8,2.9,30.4-6.8,40.1c45.9-2.3-111.3,107.1-80,62.4c-37.2,16.3-1.3,38,22.9,26.8c39.5-24.1,68.4-62.8,109.5-86.3
  c8-14.4,4.9,18.4,4.6,24c-10.5,1.6-20.4,8.9-30.9,5.4c-0.7,2.7,1.1,5.5,2.4,2.2c0.6,2.2,6.1,2.9,1.5,3.1c1.2,2.2,2.1-0.8,4,0.2
  c3.4,10.1,27.6,3.2,32.5,7.9c15.6-10.3,27.1,2.1,8.4,11.4c-14.6,3.5-27.9,16.2-42.9,15.7c-4.5,2.4,14.3,7.2-2.8,10.3
  c-5.3,17.4-15.4,11.5,0.3,16.1c6.8-4.2,43.8-9,43.3,4.9c-7.2-3.8-9.8,7.9-14.3,11.3c1.7,4.7,11.8,12.6,2.8,13.2
  c17,9.8,37.1,3.7,54.5,7.3C449.5,280.7,452.1,272.5,457,275.6z M442.5,228.8c0.1,0.4,0.2,0.8,0.2,1.2
  C441.7,230.1,442.3,229.5,442.5,228.8z M438.3,230.7c0.8,1-1.3,1.3-1.9,1.9C435.4,231.6,437.6,231.3,438.3,230.7z M465.9,119.3
  c1.1-11.9,3.6-23.1,6-34.9c12.2-5.6,66.1,7.6,40.8,21.4c20.7-3.4-4.1,5.7-2,13.5c7-5,7.5-3.7,0.7,2c3.9-0.6,3.6-1.4,6.8-3.9
  c-2.6,9.1-16.9,16.5-8.9,2.7c-4,2.2-8,4.3-12.9,6.9c1.3-3.4,2.2-5.9,3.5-9.5c-5,6-11.3,6.5-17.7,9c3.7,0.5,7.4,0.9,11.2,1.4
  c-6.2,5.5-40.9,7.5-11.1-1.5C474.7,127,462.7,130.7,465.9,119.3z M463.4,29.2c5.2-0.2,25.9-8.4,27.2-2.4c-12.5,2.7-27.1,7.2-40,7
  C454.7,31.3,458.6,29.4,463.4,29.2z M396,25.2c-0.3-0.5,1.4-0.5,1.3-0.1C396.8,25.1,396.4,25.1,396,25.2z M402.6,23.5
  c-0.6,1.5-1.7,1-3.2,0.2C400.7,23.6,401.7,23.5,402.6,23.5z M400.4,19.3c-1.7,0.9-4.5,1.7-6.8,1.9
  C395.4,18.9,397.9,19.3,400.4,19.3z M393.3,21.4c-0.7,1.4-1.7,1-3.3,0.2C391.4,21.5,392.4,21.4,393.3,21.4z M322.4,38.3
  c2-2.8,4-0.1,6,0C326.4,38.7,324.5,40.2,322.4,38.3z M369.8,79.9c1.6,0.9-1,2.1-1.5,3.2C366.5,81.9,369,81,369.8,79.9z M371.9,82.8
  c3.7,6.2,0.2,13.4-6.1,14C366.1,91.3,368.9,87.3,371.9,82.8z M368.4,105.4c-0.5,0.4-0.8-1.4-0.2-1.2
  C368.3,104.6,368.3,105,368.4,105.4z M365.5,99.5c1.8,1,1.1,2.5,1.1,4.4C364.7,102.3,363.9,101.2,365.5,99.5z M386.5,142.8
  c0.1-0.6-0.5-1.7,0.4-1.5C386.9,141.9,387.4,142.9,386.5,142.8z M384.1,127.4c-8.1,8.9-30.4,17.8-15.9-0.7
  C373.8,122.8,396.3,115.5,384.1,127.4z M389.8,105.7c-15.1,0.7-12.1-19,1.3-14.8C392.1,95.8,391,100.6,389.8,105.7z M394.7,79.6
  c-17.7-9-26.3-14.6,5.7-20.8C398.4,65.7,396.6,72.6,394.7,79.6z M404.8,223.6c-2,1.7-4.4,2.2-7.7,1.3
  C399.9,223.3,408.7,217.7,404.8,223.6z"
          />
          <path
            d="M430.9,317.6c3.8,4.1-6-1.9-7.2,2.3c-2.7-4-5.5-0.8-8.6,0.3c-4.8-2-0.5,2.6-5.1,2.8c-0.4-6-18.3,4.2-21.6,0.4
  c2.6-0.9,5.9-0.3,7.6-2c-11.6-2.4,7.3-0.1,5-4.1c4-0.6,9.4,1.7,9.6-3.2c-5.6,0.9-9.7,3.3-15.6,1.3c2.6-0.4,4.4-0.6,6.5-0.9
  c-0.8-0.6-1.2-0.8-2.2-1.5c1.9,0.1,3.1,0.1,4.3,0.2c-17.4-7.6-12.7,5.6-24.6,0.7c0.5,1.6,1.1,1,0,2.4c-37.5,3.6-74.4,9.7-110-2.3
  c-31.1-12.7-55.6-38.7-69.5-69.9c-12.7-19.9-30.1-35.7-44-55.3c4.9-4,9-7.6,8.3-14c6.5-4,12.8-17.2,16.7-8.3
  c8.3-9.8,15.5-20.2,26-28.7c-17.3-33.3-59.6-31.6-85.6-53c12-6.1-32.2-7-18.1,1.4c-27.9,16.4,28.6,33.6,2.8,48.1
  c9.6-2.4,8.3,0.6,3.5,8.2c-4.1,1-4.3,12.5-8.6,5.3c-13.7,6.8-7.1,16.2-24.7,12.4c3.5-9-13.8,14.6-18.3,6.5
  c-12.4,7.6-20.9-2-36.8,4.1c-49,20.1,28.2,45.7,49.8,46.5c-8.8,16.3-16.1,32.4-24.5,48c-4.3-0.7-7.7,4.3-5.7,8
  c-12.6,6-20,30.9-39.8,29.4c-3.2,6.6,5.8,4.6,8.7,8.7c10.9,14.5,29.1,11,31.8,21.5c0.4-6.1,1.6-3.9,5.2-0.7
  c-2.1-19,19.4-39.5,16.4-53.1c9.2-10.3,18.5-22.8,27.4-35c14-0.9,15-34.9,33.2-31.6c45.9,31.3,65.9,95.3,116.7,117.2
  c-1.6,0.5-2.4,0.7-2.9,0.9c32.9,19.3,71.8,30.2,110.6,32.5c17.3-19.7,65.6-17.7,72.2-33.7c-7.7-3.3-6.9,8.6-10.5,1.8
  C378.1,330.2,454.9,320.5,430.9,317.6z M397.4,312c-0.9,1.7-2.5,0.7-3.8,0.8C394.5,311,396.1,312.2,397.4,312z M75.5,160.6
  c-0.4,0.6-0.8,1.2-1.3,1.9C73.2,160.1,74.5,160.6,75.5,160.6z M74.3,166.5c-0.9-1.1,1.4-1.3,2.1-1.9
  C77.2,165.7,75,165.9,74.3,166.5z M81.4,170.6c-0.4-0.6,1.3-0.8,1.2-0.2C82.2,170.4,81.8,170.5,81.4,170.6z M84.3,168
  c1.9-0.1,2.8-0.2,3.7-0.3C87.4,169.2,86.3,168.7,84.3,168z M88.2,167.6c0.8-1.4,1.6-2.7,3.7-3C91.2,166.6,90.1,167.6,88.2,167.6z
   M95.2,154.5c-1.1-1.4,1.8-1.6,2.7-2.4C98.9,153.4,96,153.7,95.2,154.5z M317.2,322.9c-0.2-0.9,1.1-0.4,1.7-0.6
  C319.2,323.4,317.9,322.8,317.2,322.9z M371.5,317.7c-0.4-0.1-1.4,0.3-1.3-0.3C370.6,317.5,371.6,317.1,371.5,317.7z M393.1,313.1
  c-0.5,0.3-1.1,0.5-1.6,0.8C391.6,312.9,392.4,313,393.1,313.1z M391.8,316.5c0.6,0.5,0.5,0.8,0,1.2
  C391.1,317.4,391.6,317,391.8,316.5z M391.1,314.1c-0.6,0.4-1.1,1.3-1.4,0.2C390.2,314.3,390.6,314.2,391.1,314.1z M381.1,321.8
  c2.9-0.2,5.9-0.4,8.8-0.5C387,322,384.2,324.3,381.1,321.8z M397,324.7c0.7,0.2,2.3-0.4,2.3,0.4C398.6,324.9,397,325.5,397,324.7z
   M398,331.3c-1-1.3,1.2-1.3,2-1.8C400.8,330.5,398.6,330.7,398,331.3z M401.1,324.4c-0.6-1.3,3.4-1.3,3.3-0.3
  C403.3,324.1,402.2,324.2,401.1,324.4z M414.3,322c0.8-2,0.7-1.9,2.4-0.3C415.5,321.9,414.9,322,414.3,322z M418.7,320.9
  c0.6-0.5,0.8-0.7,1.5,0.1C419.5,320.9,419.1,320.9,418.7,320.9z"
          />
          <path
            d="M704,118.4c2.7,19.5,20.3,22.7,33.8,16.6c3.9-5.8,3.2-7.9,10.5-10.4c14.3-4.7,25.5-9.1,40.3-12.5
  c-10.2,35.9,39.3,141.1-20.9,134c-56.2,9.5-25.3-13.2-44.9-43.1c-9.6-16.8-40-4.4-48.1,4.8c-11.2,7.3-9.9,23.6-12.3,35.3
  c-5.3,5.7-9.6,11.1-4.4,14.5c0.6,3.8,1.5,8.3,5.8,7.5c3.7-2.7,10.8,2.2,12.6-1.7c0-3.8,3-4.4,5.2-5.6c0.7-6.8,10-8.2,15.2-4.6
  c8.9-1.2,15,6.6,22.6,9.2c2.2-31.7,20.9-1.4,41.3-0.8c20.7,1.2,32.8,17.5,51,23.6c6.5-8.7,18.3,3.2,18.4-7.1
  c-4-47-14.9-93.5-15.6-140.2c2.8-17.8,3.8-44.9,16.2-61.6c-2.2-4.8-4-9-2.3-14.4c-0.9-40.3-46-73-83.2-58.6
  C741,6.4,700.6,39.3,725,34.9c-8.5,7.8-5.3,5.7-0.4,12.9C714.6,69.2,695.9,93.9,704,118.4z M686.6,236.3
  c-0.2-5.8-3.8-13.3,2.9-16.7C719,205.4,719.8,242.2,686.6,236.3z M769.3,99.4c-0.4-0.8,2.6-1.1,2.2-0.1
  C770.8,99.3,770,99.3,769.3,99.4z M776.6,97.3c0-0.1,0-0.2-0.1-0.4C778.1,96.6,778.1,97.3,776.6,97.3z M782.6,96.2
  c-0.2-0.5,1.8-0.5,1.6,0C783.7,96.2,783.2,96.2,782.6,96.2z M731.5,53.4c2.1,0,0.4,0.9-0.4,1.6C731.2,54.5,731.3,54,731.5,53.4z
   M729.5,89.2c5.4-24.4,35.8-76.8,62.7-48.3c2.4,7.8,0.5,14.5-1.2,22.1c-5.4,32.2,7.2,26.1-23,19.4
  C787.6,87.9,723.3,99.9,729.5,89.2z M727.8,59.5c1.3,1.1,0.9,1.6-0.1,1.9C727.7,60.9,727.8,60.3,727.8,59.5z M727.6,61.6
  c0,0.6-0.1,1.2-0.2,2.1C726.2,62.5,726.5,61.9,727.6,61.6z M724.8,67.9c-0.7,2.8-1.2,5.6-3.2,7.8C721.5,72.7,722.3,70,724.8,67.9z
  M715.2,90.6c2.3-4.6,2.8-10.7,6.1-14.5c-1.9,8.5-5.4,16.7-7.9,24.9C712.8,97.6,714.2,94.1,715.2,90.6z"
          />
          <path
            d="M582.8,217.6c1.3,7.3,12.9,23.8,18,13c-0.3-3.9-4.9-10-1.4-12.2c3.3,6,7.6,10.6,13.8,9.3c2.9-14.3-9.4-28.8-4.4-46.1
  c-6-15.8,4.7-49.8,10.4-19.7c3.4-4.8,13.4-4.9,14-1.8c12,2.4,23.1-2.9,34.3-2.3c-9,10.2-28.4,15.5-22.7,33.3
  c18.2-7,35.6-21.5,50.7-29.5c-0.8,0.9-1.4,1.5-2.6,2.7c2.8-1.2,3.6-1.9,4.7-4c10.1,2.3,3.8-5.1,19.8-2.5
  c-11.9,10.4-26,23.4-42.6,20.2c-5.9,3.9,3.7,6-6.9,6.6c-0.7,3.5,1.2,4,4.3,5.5c-12.6,5.4-23.5,22.4-36.5,18.1
  c6.2,8.7-5.1,4.4-9,6.1c-3,7-7.7,36.9,0.3,18.7c2.8,8.8,4.1,1.2,7.1-2.2c2.5,0.6,0.8,4.7,4.5,4.6c18-28.5,76.6-70.8,102.2-31
  c10.6,2.9,13.7,19.7,25.9,17.4c-1.4-2.2-2-3.1-4.3-4.6c6.3,2.1,11.8-0.3,6.7-6c4.3-2.4,4.9-10.9-0.1-13
  c-16.6-5.9-27.3-23-45.7-23.8c5.3-6.9,12.3-12.1,19-18c-8.2-25.6-66.9,6.4-47-11.9c-2-1.4-5.9,2-9.2,2.6c25-33.3,1-62-9.1-96.4
  c5.6-60.7-73.9-13.3-70.2,18.6c-10.2,8.9-5.6,30.9-23.7,26.2c2,4.9,7.2,3.1,10.4,6c-0.9,4.7-3.1,4.4-7.5,3.4c3.7,3,3.7,3,4.9,5.9
  C582.9,145,574.4,183.3,582.8,217.6z M613.6,122.2c0.1-9.8,8.2-8.6,15.7-8c18.5-1.9,58.4-10.9,24.4-26.7c-12.5-7.1-15.1-7.3-29-5.9
  c0.7-5,0.8-13.7-5.1-15.3c12-8.3,24.9-14.2,38.1-19.6c8.2,23.1,24.5,53.1,3.3,73.8C652.2,125.9,602.6,144.5,613.6,122.2z"
          />
          <path
            d="M16.4,56.3c9.4,63.9,47.1,67.5,83.9,16.5c21.8-21.8,59.5-27.9,87.4-15.9C207,57.7,227,58,245,54.8
  c-1.9-7.1,5.3-10.2,2.1-18.4c5-6.7,22.4-8.7,5.2-9.8c2-2.9,7.7-5.6,7.5-8.7c-5.2,2.1-27.8,6.4-27.2-1.4c2.4-5.6,7.7-9.7,14.3-8.7
  c-0.7-6.5-3.9-6.5-8.6-2.9c-55.5,9.3-116.5-1.5-172.2,15.4c-12.3,3-26.7,6.4-37.5-2.1c-9.9,3.2-9.6,8.7-9,16.5
  C10,39.7,15,48.2,16.4,56.3z M119.4,29.2c16.3-5,31.8-8,49.5-5c-21.8,3.1-43.6,2.4-64.1,11.3C109,31.6,114.7,31.4,119.4,29.2z"
          />
          <path
            d="M866.3,313.7c-4.9,2.6-10.5,2.2-15.9,3.3c24.2-17.9-6.5-4.5,10.3-14.3c-4.4-0.7-3.8,1.3-7.6,0.5
  c11.3-8.6-42.9,19.5-33.7,6.8c-33.7,6.3-60.8-11.9-94.3-8c0.4-0.3,0.9-0.7,1.3-1c-74.7,15.7-148-10.8-222.2-7.7
  c5,1.6,7.6,4.8,14.8,3.4c-31.5,5.2,4.5,3.4,17.3,7.4c-5.3,3.9-17-2.8-20.1,2.4c-4.1,0.2-8.1-0.1-1.4-1.2c-5.8-1-10-0.9-13.7,0.3
  c11.6,0.4-8,4.8-10.6,0c3.1,4.3-4.5,4.4-3.2,1.1c-2.9,0.8-7-0.9-7.2,2.9c-1.6,0.8-4.1,0.8-5,2.9c39.3-5.2,86-6.2,124.6,8.5
  c-11.2,0.6-21.2-4.3-32.7-4.6c0.7,0.6,1.2,0.9,2,1.5c-2.9,0-5.4,0-8.3,0c4.7-2.8-2.7-3-4.7-2.2c9.2,4.8-28.8-7.3-33.7,2.1
  c60.6-2.1,116.4,27.1,176.2,29.1c15.5-18.6,41-16.2,63.1-19c38,6.8,77,30.6,107.5-2c-4.3-1.1-11,2.6-16.1,4.4
  c-8.8-0.4,12.2-13.9,18.1-17.2C869.1,313.1,867.1,312.8,866.3,313.7z M522.1,294.2c-3.6-0.4-9.1,0.8-11.8-0.5
  C513.9,294.1,519.3,292.9,522.1,294.2z M481.6,309.8c-0.4-1,3.4-0.9,3.3-0.2C483.8,309.6,482.7,309.7,481.6,309.8z M519.8,306.5
  c-0.2-1.1,0.5-0.5,1.2-0.2C520.6,306.4,520.2,306.5,519.8,306.5z M525,306.6c-0.4-0.6,1.3-0.8,1.2-0.2
  C525.8,306.5,525.4,306.5,525,306.6z M577.2,308.4c-0.1-0.4,1.6-0.6,1.4,0C578.2,308.4,577.7,308.4,577.2,308.4z M767.7,324
  c-0.8-0.2-2.7,0.5-2.7-0.5C765.8,323.8,767.7,323.1,767.7,324z M778.7,327.4c-0.7-1.3,2.3-1.3,2.1-0.2
  C780.1,327.2,779.4,327.3,778.7,327.4z M786.8,329.4c-0.4-1.2,1.3-0.6,2.1-0.9C789.2,329.6,787.5,329.2,786.8,329.4z M799.1,332.4
  c0.1-1.1,0.8-0.2,1.4,0.1C800.1,332.4,799.6,332.4,799.1,332.4z M801.1,332.7c1,0.1,2.2-0.6,2.8,0.8
  C802.9,333.4,801.6,334,801.1,332.7z M804.1,333.7c1,0.1,2.3-0.6,2.9,0.9C806,334.6,804.8,335,804.1,333.7z M807.2,334.7
  c2.2,0.4,4.4,0.8,7.6,1.4C811.3,337.1,809,336.8,807.2,334.7z M815.8,337.6c-0.3-0.7,0.7-0.4,1.2-0.6
  C817.2,337.6,816.2,337.4,815.8,337.6z"
          />
          <path
            d="M447.5,316.4c-4.4-2.3-4.9,1.5-10.6,2.1C439.4,323.2,445.2,319.8,447.5,316.4z"
          />
          <path
            d="M416.9,315c-1.2,1.4-1.8,2.1-2.8,3.2c2.9-0.6,4.6-0.8,3-3.4c3.3-0.7,6.5-0.5,9-2.7c-5-0.3-9.7,0.8-13.9,3.9
  C413.5,315.7,414.7,315.4,416.9,315z"
          />
          <path
            d="M492.5,295.5C492.5,295.4,492.5,295.4,492.5,295.5C492,295.5,493,295.6,492.5,295.5z"
          />
          <path
            d="M503.9,293.5c-5.4-0.3-6,2.9-11.2,2.1c3,3.2,9.9-0.9,13.9-0.5c-0.7-0.5-2.3-1.1-2.5-1.6c-0.1,0-0.2,0-0.3,0L503.9,293.5z"
          />
          <path
            d="M865.3,300.9c-2.4-0.4-2.3-0.9-1.4-3.3c-2.6,1.5-6,0.4-6.8,4.2c2.1-0.3,5.7-2.5,3.8,0.8C862,301.9,865.1,301.9,865.3,300.9
  z"
          />
          <path
            d="M860.8,302.6c-0.1,0-0.2,0-0.2,0.1C860.7,302.8,860.8,302.7,860.8,302.6z"
          />
          <path
            d="M443.3,325.4c4,1.3,4.3,1.3,7.2-2.3c-2.7,1-5.9-0.1-8.4,2.1C442.6,325.3,443,325.3,443.3,325.4z"
          />
          <path
            d="M481.7,303.8c3.4-0.6,6-1,8.7-1.5C487.5,301.4,484.5,300.7,481.7,303.8z"
          />
          <path
            d="M468,315c1.7-0.9,3.1-1.7,5-2.7C469.9,312.6,464.2,310.9,468,315z"
          />
          <path
            d="M460.4,315.1c-3.1,0.5-6.6-1.6-8.4,2C455.2,316.2,458.7,317,460.4,315.1z"
          />
          <path
            d="M311.5,157.7c-1.8,1.1-3.7,2.1-6.5,3.8C309,161.7,310.2,159.6,311.5,157.7z"
          />
          <path
            d="M273.5,16.9c0-0.8,0-1.6,0-3C269.6,13.8,269.9,18,273.5,16.9z"
          />
          <path
            d="M460.7,314.9c-0.1,0-0.3,0-0.3,0.2C460.5,315.1,460.6,315.1,460.7,314.9z"
          />
          <path
            d="M465.5,313.3c-2.4-1.6-3.4-0.5-4.8,1.7C462.4,314.5,464.7,315.2,465.5,313.3z"
          />
          <path
            d="M431.6,333.8c0.7-1.1,1.2-1.9,2.1-3.4c-2.2,0.7-3.6,1.1-6,1.8C429.6,333,430.6,333.4,431.6,333.8z"
          />
          <path
            d="M297.2,168.9c1.7-1.3,3.4-2.6,5.3-4.1C299.1,164.1,298.4,166.8,297.2,168.9z"
          />
          <path
            d="M261.1,0.8c-2.8,0-5.6,0-8.4,0C255.5,1.3,258.3,2.4,261.1,0.8z"
          />
          <path
            d="M494.8,319.9c2.9-0.1,5.1,1.8,7.6-0.5C499.3,319.7,496.2,318.5,494.8,319.9z"
          />
          <path d="M871,295.4c-0.1,0.2,0,0.1,0.1,0.1L871,295.4z" />
          <path
            d="M870.9,295.5c-2.1-0.3-3.6,0.7-4.8,2.5C867.9,297.6,869.8,297.3,870.9,295.5z"
          />
          <path
            d="M401.6,319.2c0,0,0.1-0.1,0.1-0.1C401.6,319.1,401.5,319.2,401.6,319.2z"
          />
          <path
            d="M403,320.4c5-1.3-2.1-2.4-3.4,1C401.2,321,402.1,320.7,403,320.4z"
          />
          <path
            d="M855.7,302.7c0-0.1-0.1-0.1-0.2-0.1C855.5,302.8,855.6,302.7,855.7,302.7z"
          />
          <path
            d="M868.3,303.7c-1.2,0.7-2.3,1.3-3.5,2C866.5,306.1,867.8,305.6,868.3,303.7z"
          />
          <path
            d="M429.7,312c-0.1-0.1-0.2-0.1-0.2,0C429.5,312.1,429.6,312.1,429.7,312z"
          />
          <path
            d="M433.4,311.3c-1.4-0.1-2.8-1.1-3.7,0.7C431,312.8,432.2,312.5,433.4,311.3z"
          />
          <path
            d="M457.2,9c-1.6-0.1-3.2-0.1-4.6,0.6C454.1,9.4,456,10.9,457.2,9z"
          />
          <path
            d="M439.2,327.3c0.9-0.7,1.7-1.3,2.5-1.9C439.6,324.9,439.6,324.9,439.2,327.3z"
          />
          <path
            d="M441.7,325.4c0.2,0.1,0.3,0.1,0.4-0.1C442,325.3,441.8,325.2,441.7,325.4z"
          />
          <path
            d="M435.9,303.6c1.5,0,3,0,4.6,0C438.9,303,437.3,302.1,435.9,303.6z"
          />
          <path
            d="M426.5,311.9c-0.1-0.1-0.2,0-0.3,0.1C426.3,312,426.5,312.1,426.5,311.9z"
          />
          <path
            d="M429.4,312c-1-0.2-1.9-1.9-2.9-0.1C427.5,312.2,428.4,313.9,429.4,312z"
          />
          <path
            d="M494.2,299.6c-0.9,0.9,1.1,1.4,1.7,2.1C497.3,300.5,495.1,300.3,494.2,299.6z"
          />
          <path
            d="M322.5,150.1c-1,0.5-3.1,0.5-1.9,1.9C321.3,151.3,323.3,151.1,322.5,150.1z"
          />
          <path
            d="M403.4,310.1c-1.1,0.3-3.5-0.7-3.3,0.8C401,310.6,403.5,311.4,403.4,310.1z"
          />
          <path
            d="M491.3,293.7c-1.3,0.9-0.3,1.9,1,1.7C492.5,294.6,491.9,294.2,491.3,293.7z"
          />
          <path
            d="M415.7,307.1c-0.2,1.3,2.3,0.3,3.3,0.5C418.9,306.5,416.6,307.3,415.7,307.1z"
          />
          <path
            d="M422.5,309.1c-0.1,0.4,0.2,0.9,0.5,1.8C425.1,308.8,423.5,307.1,422.5,309.1z"
          />
          <path
            d="M478.6,295.5c-1.7,0.2-2.5,0.3-3.9,0.5C476.6,298.3,476.5,297,478.6,295.5z"
          />
          <path
            d="M457.5,8.9c-0.1,0-0.2,0-0.3,0.1C457.4,9,457.5,9,457.5,8.9z"
          />
          <path
            d="M457.5,8.9c1.2-0.1,2.4-0.1,3.7-0.2C459.9,8.3,458.5,7.2,457.5,8.9z"
          />
          <path
            d="M385.9,313.3c-1.1,0.2-3.6-1-3.3,0.7C383.6,313.6,385.9,314.4,385.9,313.3z"
          />
          <path
            d="M513.5,318c0.7-0.2,2.4,0.4,2.3-0.6C514.9,317.5,513.4,316.6,513.5,318z"
          />
          <path
            d="M49.7,165.6c0.7-0.7,1.6-1.2,0.4-1.9C49.5,164.4,48.6,164.9,49.7,165.6z"
          />
          <path
            d="M464.5,321.3c-0.9,0-1.8,0.1-3.2,0.2C462.8,322.2,463.9,322.9,464.5,321.3z"
          />
          <path
            d="M464.5,321.3c0.1,0,0.1,0,0.2,0C464.6,321.2,464.5,321.1,464.5,321.3z"
          />
          <path
            d="M454.1,223.8c-0.1-0.8,0.7-2.5-0.5-2.3C453.7,222.3,453,224,454.1,223.8z"
          />
          <path
            d="M501.8,315.5c0.6,0.8,1.2-0.5,1.8-0.8C502.8,313.5,502.4,314.9,501.8,315.5z"
          />
          <path
            d="M488.5,297.4c-0.7-0.1-1.8-1.4-2.1-0.4C487.2,297.7,487.8,298.9,488.5,297.4z"
          />
          <path
            d="M471.1,299.3c0.9-0.1,2.4,0.8,2.3-0.6C472.7,298.9,471,298.3,471.1,299.3z"
          />
          <path
            d="M458.8,325.7c-0.4,0.9,2.4,0.6,2.2,0C460.3,325.7,459.5,325.7,458.8,325.7z"
          />
          <path
            d="M477.9,303.8c-0.9,0.1-1.8,0.1-3.3,0.2C476.2,304.6,477.3,305.3,477.9,303.8z"
          />
          <path
            d="M481.5,305.5c1,0,2.5,0.8,2.3-0.7C483,305,481.3,304.4,481.5,305.5z"
          />
          <path
            d="M421.6,306.1c-0.1,1,1.6,0.2,2.4,0.4C424.1,305.2,422.4,306.2,421.6,306.1z"
          />
          <path
            d="M466.2,7.6c0.2-0.6-2.4-0.6-2.2,0C464.7,7.6,465.4,7.6,466.2,7.6z"
          />
          <path
            d="M460.6,14c-0.1,0-0.1,0-0.2,0.1C460.4,14.1,460.5,14.2,460.6,14z"
          />
          <path d="M460.6,14c0.9,0,1.8,0,3.4,0C462.2,13,461.2,12.6,460.6,14z" />
          <path
            d="M370.9,20.2c-0.1,0-0.2,0-0.2,0.1C370.8,20.4,370.8,20.3,370.9,20.2z"
          />
          <path
            d="M372,18.3c-0.4,0.8-0.8,1.4-1.1,1.9C371.8,20.1,373.2,20.4,372,18.3z"
          />
          <path
            d="M554.9,312.2c-0.7,0.2-2.6-0.5-2.3,0.6C553.2,312.5,555,313.1,554.9,312.2z"
          />
          <path
            d="M328.2,146.2c-0.8,0.3-2.6-0.3-2.3,0.8C326.7,146.7,328.5,147.3,328.2,146.2z"
          />
          <path
            d="M872.7,312.1c-0.4,0.2-0.9,0.5-1.3,0.7C872,312.7,873.3,313,872.7,312.1z"
          />
          <path
            d="M870.8,313.1c0.2,0,0.4-0.1,0.6-0.2C871.2,312.9,870.9,312.9,870.8,313.1z"
          />
          <path
            d="M749.6,301.5c0.6-0.2,1.7,0.2,1.4-0.7C750.4,301,749.3,300.7,749.6,301.5z"
          />
          <path
            d="M453.5,302.5c0.8-0.3-0.5-1.2-0.9-0.3C452.9,302.3,453.2,302.5,453.5,302.5z"
          />
          <path
            d="M756.1,302.4c0.1-0.6-0.8-0.3-1.2-0.4C754.7,302.6,755.6,302.3,756.1,302.4z"
          />
          <path
            d="M108.3,135.8c-0.4,0-0.8,0.1-1.2,0.1C107,137,108.6,136.6,108.3,135.8z"
          />
          <path
            d="M478.3,303.6c-0.2,0-0.4,0-0.4,0.2C478.1,303.8,478.2,303.7,478.3,303.6z"
          />
          <path
            d="M479.4,302.6c-0.4,0.3-0.7,0.6-1.1,0.9C479,303.4,480.2,303.6,479.4,302.6z"
          />
          <path
            d="M469.2,319.5c-1.7,0-1,0.8,0.2,0.3C469.3,319.7,469.2,319.5,469.2,319.5z"
          />
          <path
            d="M464.7,321.3c0.1-0.1,0.2-0.1,0.3-0.2C464.8,321.2,464.3,321.1,464.7,321.3z"
          />
          <path
            d="M465,321.1c0.5-0.1,0.9-0.1,1.4-0.2C466.3,320,465.6,320.9,465,321.1z"
          />
          <path
            d="M435.4,303.8c0.2,0,0.4,0,0.5-0.2C435.7,303.6,435.5,303.7,435.4,303.8z"
          />
          <path
            d="M434.2,304.6c0.4-0.3,0.8-0.5,1.2-0.8C434.7,304,433.5,303.7,434.2,304.6z"
          />
          <path
            d="M587.8,294.1c0.4-0.1,1.2,0.1,1-0.5C588.4,293.8,587.6,293.6,587.8,294.1z"
          />
          <path
            d="M483.6,321.6c-0.2,0.6,1.5,0.4,1.4,0C484.5,321.6,484.1,321.6,483.6,321.6z"
          />
          <path
            d="M871.3,304.3c0.5-0.1,1.5,0.3,1.3-0.4C872.2,304.1,871.2,303.8,871.3,304.3z"
          />
          <path
            d="M440.3,304.9c-0.4,0.1-0.8,0.2-1.2,0.3C439.9,305.5,440.5,306.1,440.3,304.9z"
          />
          <path
            d="M872.5,294.5c-0.4,0.3-0.8,0.6-1.1,0.8C872.1,295.2,873.2,295.4,872.5,294.5z"
          />
          <path
            d="M871.4,295.4c-0.1,0-0.3,0-0.4,0.1C871.1,295.6,871.2,295.4,871.4,295.4z"
          />
          <path
            d="M499.1,306c-1.6,0-1,0.8,0.2,0.3C499.2,306.2,499.1,306,499.1,306z"
          />
          <path
            d="M494.9,294.3c0.4-0.2,1.4,0,1.2-0.6C495.5,293.7,494.7,293.4,494.9,294.3z"
          />
          <path
            d="M425.1,327.9c-0.4,0.1-1.3-0.3-1.2,0.3C424.2,328.1,425.1,328.3,425.1,327.9z"
          />
          <path
            d="M420.7,329.4c-0.2,0.1-0.4,0-0.5,0.2C420.3,329.6,420.5,329.5,420.7,329.4z"
          />
          <path
            d="M421.8,328.6c-0.4,0.3-0.8,0.5-1.2,0.8C421.3,329.2,422.5,329.4,421.8,328.6z"
          />
          <path
            d="M824,308.4c0.6,0.1,0.2-0.7,0.2-1.2C823.6,307.3,824,308,824,308.4z"
          />
          <path
            d="M863.5,307.5c0.1-0.7-1-0.2-1.5-0.4C861.9,307.8,863,307.3,863.5,307.5z"
          />
          <path
            d="M424.6,333.9c-0.2,0.9,0.9,0.4,1.5,0.4C426.2,333.6,425.1,334.1,424.6,333.9z"
          />
          <path
            d="M266.1,16.8c0-0.6-0.7-0.1-1.1-0.2C264.9,17.2,265.7,16.7,266.1,16.8z"
          />
          <path
            d="M410.6,312.4c-0.4,0.1-1.4-0.3-1.3,0.4C409.7,312.6,410.7,312.9,410.6,312.4z"
          />
          <path
            d="M53.5,163.3c0.4-0.2,1.4,0.1,1.3-0.4C54.3,163,53.3,162.6,53.5,163.3z"
          />
          <path
            d="M68.6,156c0.6-0.1,1.8,0.4,1.6-0.5C69.7,155.6,68.5,155.2,68.6,156z"
          />
          <path
            d="M455.7,326.8c0,0.6,0.7,0.1,1.2,0.2C456.9,326.4,456.2,326.8,455.7,326.8z"
          />
          <path
            d="M745,71.4c12.8,5.9,42.1-3.7,30.2-19.2C767.1,48.8,733.6,66.2,745,71.4z"
          />
        </g>
      </svg>
      <p>LOADING</p>
      <div class="loading-ripple">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  props: ["state"],
};
</script>

<style lang="scss" scoped>
#loading {
  font-family: serif;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: linear-gradient(#eee, #ddd);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    fill: #aaa;
    width: 50vw;
    height: auto;
    max-width: 320px;
  }
  p {
    color: #aaa;
    margin-top: 1em;
    font-size: 1.5rem;
  }
  .loading-ripple {
    position: absolute;
    left: 0%;
    top: 0%;
    width: 100%;
    height: 100%;
    overflow: hidden;
    span {
      position: absolute;
      left: calc(50% - 25vmax);
      top: calc(50% - 25vmax);
      width: 50vmax;
      height: 50vmax;
      border-radius: 50%;
      border: 1px solid #bbb;
      animation: ripple 3s ease-out 0s 3;
      opacity: 0;
      &:nth-child(1) {
      }
      &:nth-child(2) {
        animation-delay: 0.2s;
      }
      &:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }
}
.opacity-enter {
  opacity: 0;
}
.opacity-enter-active {
  transition: opacity 1s;
}
.opacity-enter-to {
  opacity: 1;
}
.opacity-leave {
  opacity: 1;
}
.opacity-leave-active {
  transition: opacity 1s;
}
.opacity-leave-to {
  opacity: 0;
}
</style>
